{
  "name": "cacache",
  "version": "17.0.4",
  "cache-version": {
    "content": "2",
    "index": "5"
  },
  "description": "Fast, fault-tolerant, cross-platform, disk-based, data-agnostic, content-addressable cache.",
  "main": "lib/index.js",
  "files": [
    "bin/",
    "lib/"
  ],
  "scripts": {
    "test": "tap",
    "snap": "tap",
    "coverage": "tap",
    "test-docker": "docker run -it --rm --name pacotest -v \"$PWD\":/tmp -w /tmp node:latest npm test",
    "lint": "eslint \"**/*.js\"",
    "npmclilint": "npmcli-lint",
    "lintfix": "npm run lint -- --fix",
    "postsnap": "npm run lintfix --",
    "postlint": "template-oss-check",
    "posttest": "npm run lint",
    "template-oss-apply": "template-oss-apply --force"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/npm/cacache.git"
  },
  "keywords": [
    "cache",
    "caching",
    "content-addressable",
    "sri",
    "sri hash",
    "subresource integrity",
    "cache",
    "storage",
    "store",
    "file store",
    "filesystem",
    "disk cache",
    "disk storage"
  ],
  "license": "ISC",
  "dependencies": {
    "@npmcli/fs": "^3.1.0",
    "fs-minipass": "^3.0.0",
    "glob": "^8.0.1",
    "lru-cache": "^7.7.1",
    "minipass": "^4.0.0",
    "minipass-collect": "^1.0.2",
    "minipass-flush": "^1.0.5",
    "minipass-pipeline": "^1.2.4",
    "p-map": "^4.0.0",
    "promise-inflight": "^1.0.1",
    "ssri": "^10.0.0",
    "tar": "^6.1.11",
    "unique-filename": "^3.0.0"
  },
  "devDependencies": {
    "@npmcli/eslint-config": "^4.0.0",
    "@npmcli/template-oss": "4.11.0",
    "tap": "^16.0.0"
  },
  "engines": {
    "node": "^14.17.0 || ^16.13.0 || >=18.0.0"
  },
  "templateOSS": {
    "//@npmcli/template-oss": "This file is partially managed by @npmcli/template-oss. Edits may be overwritten.",
    "windowsCI": false,
    "version": "4.11.0"
  },
  "author": "GitHub Inc.",
  "tap": {
    "nyc-arg": [
      "--exclude",
      "tap-snapshots/**"
    ]
  }
}
